export const locale = {
  lang: 'pt',
  data: {
    NAV: {
      ADMIN: 'Área Administrativa',
      CATALOG: 'Catálogo',
      CUSTOMER: 'Clientes',
      CUSTOMER_AREA: 'Área Clientes',
      CUSTOMERAREA: {
        PRODUCTION: 'Documentos',
        RATE: 'Preço',
      },
      DIRECTORY: 'Directorio',
      HOME: {
        TITLE: 'Página inicial',
      },
      INVOICE: 'Faturas',
      ITEM: 'Artigos',
      JOURNAL: 'Jornales',
      LABORATORY: 'Laboratórios',
      LABORATORY_AREA: 'Área Prothesist',
      MANUFACTURER: 'Fabricantes',
      MATERIAL: 'Matéria prima',
      PATIENT: 'Pacientes',
      PAYMENT: 'Regulamentos',
      PRODUCTION: 'Fluxo de trabalho',
      PURCHASE_INVOICE: 'Faturas de compra',
      RATE: 'Preços',
      RESOURCE: 'Recursos',
      SHADE: 'Cores',
      USER: 'Contas de utilizador',
    },
  },
};
